import { DataDisplay, Text } from "@certn/cascadia-react";
import {
  AdjudicationStatus,
  AdjudicationStatusTag,
} from "../../../utils/renderStatusTag";
import { useTranslation } from "react-i18next";
import { OutcomeSchema } from "../../adjudication/types";
import { InferType, number, object } from "yup";

type Props = {
  adjudicationResults: unknown;
};

const schema = object({
  outcome: OutcomeSchema.required(),
  date_variance: number().required(),
});

const validateAdjudicationResults = (
  adjudicationResults: unknown
): InferType<typeof schema> | null => {
  try {
    return schema.validateSync(adjudicationResults);
  } catch (error) {
    console.error(error);
    return null;
  }
};

export function ChildEmploymentVerificationAdjudicationResults({
  adjudicationResults,
}: Props) {
  const { t } = useTranslation();
  const validatedAdjudicationResults =
    validateAdjudicationResults(adjudicationResults);

  if (!validatedAdjudicationResults) {
    return null;
  }

  return (
    <DataDisplay
      renderTopMargin={false}
      columns={[
        {
          key: "rule",
          name: t("Rule"),
          isRowHeader: true,
          width: "80%",
          render: ({ rule }) => <Text style="global/body-primary">{rule}</Text>,
        },
        {
          key: "outcome",
          name: t("Adjusted score"),
          render: ({ outcome }) =>
            AdjudicationStatusTag(outcome as AdjudicationStatus),
          width: "20%",
        },
      ]}
      rows={[
        {
          key: "date-variance",
          rule: t(
            "Date Variance (start/end dates) - {{dateVariance}} Threshold days",
            {
              dateVariance:
                validatedAdjudicationResults.date_variance <= 90
                  ? "≤ 90"
                  : "> 90",
            }
          ),
          outcome: validatedAdjudicationResults.outcome,
        },
      ]}
    />
  );
}
